import { Controller, useFormContext } from 'react-hook-form'

import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Type = ({ index }: { index: number }) => {
  const { control, setValue } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.type`}
      control={control}
      render={({ field }) => (
        <FF2
          label="Event Type"
          field={field}
          input={(props) => (
            <Select
              {...props}
              data={[
                { label: 'Command and control IP address', value: 'Command and control IP address' },
                { label: 'Command and control URL/domain', value: 'Command and control URL/domain' },
                {
                  label: 'Malware MD5, Malware SHA-1, or Malware SHA-256',
                  value: 'Malware MD5, Malware SHA-1, or Malware SHA-256'
                },
                { label: 'Media Access Control (MAC) Address', value: 'Media Access Control (MAC) Address' },
                { label: 'Port', value: 'Port' },
                { label: 'Suspicious e-mail address', value: 'Suspicious e-mail address' },
                { label: 'Suspicious file name', value: 'Suspicious file name' },
                { label: 'Suspicious IP address', value: 'Suspicious IP address' },
                { label: 'Suspicious URL/domain', value: 'Suspicious URL/domain' },
                { label: 'Targeted system', value: 'Targeted system' },
                { label: 'Other', value: 'Other' }
              ]}
              emptyOption={{ label: 'Not selected', value: null }}
              onChange={(value: string) => {
                if (!(value && ['Command and control IP address', 'Suspicious IP address'].includes(value))) {
                  setValue(`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.date`, null)
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
